import { create } from "zustand"
import {
  ELanguage,
  type IToken,
  type TSplashConfig,
  type TTokenState,
} from './store';

import {
  DEFAULT_SPLASH_VIDEO_DETAILS,
  USER_TOKEN,
} from '../appConstants/AppConstant';
import { persist, createJSONStorage } from 'zustand/middleware';
import { resetAllStores } from "../utils/ResetStoresOnLogout";
import LocalStorageWrapper from "../common/@database/localStorage";
// import { navigateAndReset } from '@core/RootNavigation';

const initialTokenState = {
  token: {} as IToken,
  splashConfig: DEFAULT_SPLASH_VIDEO_DETAILS,
  language: 'en' as ELanguage,
  cxLanguage: 'hi' as ELanguage,
  serialNumber: '',
  fcmToken: '',
};

export const useTokenStore = create<TTokenState>()(
  persist(
    (set) => ({
      ...initialTokenState,

      resetTokenStore: () => set((state) => {
        return {
          ...initialTokenState,
          serialNumber: state.serialNumber,
          language: state.language,
        };
      }),
    }),
    {
      name: USER_TOKEN,
      storage: createJSONStorage(
        () =>
          new LocalStorageWrapper(),
      ),
    },
  ),
);

export function logout() {
  resetAllStores();
  // navigateAndReset(NAVIGATION_ROUTES.SPLASH);
}

export function dispatchToken(token: IToken) {
  const state = useTokenStore.getState();
  useTokenStore.setState({ ...state, token });
}